<template>
  <div>
    <img class="image" :src="adList[0].other2PicUrl" alt="" @click="jumpTo(adList[0].url)"/>
    <div class="title">重点推荐产品</div>
    <div class="list">
      <Grid :column-num="2" :gutter="10" :center="false">
        <GridItem @click="toProtype(item.id)" v-for="(item, index) of goodsList.filter(g => g.isVip)" :key="index">
          <div class="item">
            <img class="itemImage" :src="item.planPicDTOS && item.planPicDTOS[0] && item.planPicDTOS[0].url" alt="">
            <p class="itemText">{{ item.name }}</p>
          </div>
        </GridItem>
      </Grid>
    </div>
    <div class="title">本系列全部产品</div>
    <div class="list">
      <Grid :column-num="2" :gutter="10" :center="false">
        <GridItem @click="toProtype(item.id)" v-for="(item, index) of goodsList" :key="index">
          <div class="item">
            <img class="itemImage" :src="item.planPicDTOS && item.planPicDTOS[0] && item.planPicDTOS[0].url" alt="">
            <p class="itemText">{{ item.name }}</p>
          </div>
        </GridItem>
      </Grid>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Grid, GridItem, Toast } from 'vant';
import config from "../config";
import store from "../store";
export default {
  name: "Protype",
  components: {
    Grid,
    GridItem
  },
  data() {
    return {
      goodsList: [],
      adList: []
    }
  },
  methods: {
    getAd() {
      axios.get(`${config.publicPath}/exchange-api/api/ad/page`).then(res => {
        if (res.data.code === 0) {
          this.adList = res.data.data.list
        }
      })
    },
    jumpTo (url) {
      window.location.href = url
    },
    toProtype (id) {
      this.$router.push({
        path: `/protype/${id}`,
        query: {
          cant: id === store.state.onlyPlanId ? 0 : 1
        }
      })
    }
  },
  mounted() {
    this.getAd()
    axios.get(`${config.publicPath}/exchange-api/api/plan/page?page=1&limit=-1`).then(res => {
      const { code, msg, data } = res.data
      if (code === 0) {
        this.goodsList = data.list
      } else {
        Toast.fail(msg)
      }
    })
  }
}
</script>

<style scoped lang="less">
.image {
  width: 100%;
  object-fit: contain;
}
  .title {
    margin: 20px 0 10px 10px;
    border-left: #1989fa solid 4px;
    padding: 4px 10px;
    font-weight: bold;
  }


  .list {
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
    .itemImage {
      width: 140px;
      height: 140px;
      object-fit: cover;
    }
    .itemText {
      font-size: 12px;
      width: 100%;
      margin: 10px 0 0 0;

      line-height: 1.5;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      max-height: 72px;
      padding: 0 6px;
      box-sizing: border-box;
    }
  }
</style>